export default __webpack_public_path__ + "static/media/hero-girl-combing-dog.45bd5523.jpg";